import { createSelector } from '@reduxjs/toolkit';
import { TStoreState } from 'redux/types';
import {
	TSupportedPostalOperator,
	TSupportedPostalOperatorListResponse,
	TSupportedPostalOperatorsManagementRequest,
	TSupportedPostalOperatorsStore,
} from './types';

export const getSupportedPostalOperatorsState = (
	state: TStoreState,
): TSupportedPostalOperatorsStore => state.supportedPostalOperators;

export const getSupportedPostalOperatorList = createSelector(
	[getSupportedPostalOperatorsState],
	(state: TSupportedPostalOperatorsStore): TSupportedPostalOperatorListResponse | null =>
		state.list,
);

export const getSupportedPostalOperatorListLoading = createSelector(
	[getSupportedPostalOperatorsState],
	(state: TSupportedPostalOperatorsStore): boolean => state.listLoading,
);

export const getSupportedPostalOperatorLastListParams = createSelector(
	[getSupportedPostalOperatorsState],
	(state: TSupportedPostalOperatorsStore): TSupportedPostalOperatorsManagementRequest | null =>
		state.lastListParams,
);

export const getSupportedPostalOperatorDetails = createSelector(
	[getSupportedPostalOperatorsState],
	(state: TSupportedPostalOperatorsStore): TSupportedPostalOperator | null => state.details,
);

export const getSupportedPostalOperatorDetailsLoading = createSelector(
	[getSupportedPostalOperatorsState],
	(state: TSupportedPostalOperatorsStore): boolean => state.detailsLoading,
);

export const getSupportedPostalOperatorSaveLoading = createSelector(
	[getSupportedPostalOperatorsState],
	(state: TSupportedPostalOperatorsStore): boolean => state.saveLoading,
);

export const getSupportedPostalOperatorSaveSuccess = createSelector(
	[getSupportedPostalOperatorsState],
	(state: TSupportedPostalOperatorsStore): boolean => state.saveSuccess,
);

export const getSupportedPostalOperatorDeleteLoading = createSelector(
	[getSupportedPostalOperatorsState],
	(state: TSupportedPostalOperatorsStore): boolean => state.deleteLoading,
);
